import styled from 'styled-components';

export const UserEmail = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #999;
`;
